import { render, staticRenderFns } from "./FlexiquoteModuleDetail.vue?vue&type=template&id=2e4e1d42&scoped=true"
import script from "./FlexiquoteModuleDetail.vue?vue&type=script&lang=js"
export * from "./FlexiquoteModuleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e1d42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e4e1d42')) {
      api.createRecord('2e4e1d42', component.options)
    } else {
      api.reload('2e4e1d42', component.options)
    }
    module.hot.accept("./FlexiquoteModuleDetail.vue?vue&type=template&id=2e4e1d42&scoped=true", function () {
      api.rerender('2e4e1d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/flexiquotemodule/FlexiquoteModuleDetail.vue"
export default component.exports